import React, { useState, cloneElement, isValidElement } from "react";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import "./CardWrapper.scss";
import CategoryRadarChart from "./DataEstateCards/CategoryRadarChart";

// Inline "filter/sliders" icon — no extra icon-package dependency needed
export function FilterIcon(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      {...props}
    >
      <line x1="4" y1="6" x2="20" y2="6" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="18" x2="20" y2="18" />
      <circle cx="9" cy="6" r="2" fill="currentColor" stroke="none" />
      <circle cx="15" cy="12" r="2" fill="currentColor" stroke="none" />
      <circle cx="7" cy="18" r="2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export default function CardWrapper({ title, rightElement, children }) {
  const [showSpider, setShowSpider] = useState(true);
  const [showRegulatedFilters, setShowRegulatedFilters] = useState(false);

  const isCategorySummary = title === "Category";
  const isSensitivitySummary = title === "Sensitivity" || title === "Regulated";
  const isRegulated = title === "Regulated";
  const isDuplicateCard = title === "Data Duplication & Accessibility Index";

  // Pass the filter-visibility state down to the child card (e.g. DataEstateRegulatedCard)
  const childrenWithProps =
    isRegulated && isValidElement(children)
      ? cloneElement(children, { showFilters: showRegulatedFilters })
      : children;

  return (
    <div className="card-wrapper">
      {title !== "Size Analysis" && (
        <div
          className={
            isCategorySummary || isSensitivitySummary
              ? "card-header category"
              : isDuplicateCard
              ? "card-header duplicate"
              : "card-header"
          }
        >
          <span className="card-header-title">
            {title}
            {isRegulated && (
              <IconButton
                size="small"
                className="regulated-info-icon"
                onClick={() => setShowRegulatedFilters((prev) => !prev)}
                aria-label="Toggle classification filters"
                title="Regulation filters"
              >
                <FilterIcon />
              </IconButton>
            )}
          </span>

          <div className="data-estate-category-toggle">
            {isCategorySummary && (
              <FormControlLabel
                control={
                  <Switch
                    checked={showSpider}
                    onChange={() => setShowSpider(!showSpider)}
                    color="primary"
                    sx={{
                      transform: "scale(0.8)",
                      marginRight: "-6px",
                    }}
                  />
                }
              />
            )}

            {rightElement}
          </div>
        </div>
      )}

      {isCategorySummary && showSpider ? (
        <div className="spider-graph-box">
          <CategoryRadarChart />
        </div>
      ) : (
        <div className={title !== "Size Analysis" ? "card-body" : null}>
          {childrenWithProps}
        </div>
      )}
    </div>
  );
}